import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC } from 'react';

interface IFooter {
  height: number;
  sideNavWidth: number;
}

export const Footer: FC<IFooter> = ({ height, sideNavWidth }) => {
  const classes = useStyles({ sideNavWidth });

  return (
    <AppBar
      className={classes.footerContainer}
      position="relative"
      sx={{ height }}
      component="footer"
    >
      <Toolbar disableGutters>
        <Box padding="0 1rem">
          <Typography variant="caption">
            © Stone Martin Builders, LLC {new Date().getFullYear()}. All Rights Reserved.
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

const useStyles = makeStyles<Theme, { sideNavWidth: number }>((theme: Theme) => {
  return {
    footerContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.accent?.main,
      color: theme.palette.common.white,
      [theme.breakpoints.up('sm')]: {
        width: ({ sideNavWidth }) => `calc(100% - ${sideNavWidth}px)`,
        marginLeft: ({ sideNavWidth }) => sideNavWidth
      },
      '@media print': {
        backgroundColor: '#ffffff',
        boxShadow: 'none'
      }
    }
  };
});
